import React, { useContext, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { FaChevronDown, FaChevronRight, FaPlus } from 'react-icons/fa';
import { BsPlus } from "react-icons/bs";
import { ReportPageType, ReportSection } from '../../../core/constants/common';
import './Reporting.scss';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { SidebarContext } from '../../../App';
import ReportingUtils from '../../../core/utilities/ReportingUtils';
import { Modal, Button } from 'react-bootstrap';
import ConfirmPopup from '../../../core/utilities/ConfirmPopup';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
const ReportingSidebar = ({
  t,
  sections,
  activeSectionIndex,
  activePageIndex,
  onPageChange,
  onAddingNewSection,
  onAddingNewPage,
  onDeletingSection,
  onDeletingPage,
  onUpdatingSection,
  onUpdatingPage,
  onContentEdited,
  onReorderPage,
  onAddingNewPageFromSuggestion
}) => {
  const [showNewSectionEditor, setShowNewSectionEditor] = useState(false);
  const inputRef = useRef([]);
  const [editedSections, setEditedSections] = useState({});
  const [editedPages, setEditedPages] = useState({});
  const [renderedOn, setRenderedOn] = useState(0);
  const [draggedPage, setDraggedPage] = useState({ pageId: null, sectionId: null });
  const [draggedOver, setDraggedOver] = useState({ pageId: null, sectionId: null });
  const { sidebarDisplay, setSidebarDisplay } = useContext(SidebarContext);
  const [hiddenSection, setHiddenSection] = useState({});
  const [itemToDelete, setItemToDelete] = useState({ forSection: false, section: null, page: null });

  const onPageDragStart = (e, page, section) => {
    setDraggedPage({ pageId: page.index, sectionId: section.index });
  };

  const onPageDragEnd = (e, page) => {
    onReorderPage({
      page: draggedPage,
      over: draggedOver
    });
    setDraggedOver({});
    setDraggedPage({});
  };

  const onDragOver = (e, page, section) => {
    setDraggedOver({ pageId: page.index, sectionId: section.index });
  };
const saveChangesConfirmationCallBack=(val)=>{
  if (!val) {
    setItemToDelete({ section: null, page: null });
    return;
  }
  {
    if (itemToDelete.forSection) {
      onDeletingSection(itemToDelete.section.index);
    } else {
      onDeletingPage(itemToDelete.section.index, itemToDelete.page.index);
    }
    setItemToDelete({ forSection: false, section: null, page: null });
    onContentEdited(false);
  }
}
  const getEditTextField = ({ forSection, section, page, value }) => {
    let inputId;
    if (forSection) {
      inputId = `sectionInput-${section.index}`;
    } else {
      inputId = `pageInput-${section.index}-${page.index}`;
    }
    return (<div>
      <div>
        <input type="text"
          id={inputId}
          className="form-control"
          maxLength={100}
          ref={ref => inputRef.current[inputId] = ref}
          defaultValue={value} />
      </div>
      <div className='mt-2'>
        <button className='btn-primary me-2'
          onClick={() => {
            if (forSection) {
              onUpdatingSection(section.index, inputRef.current[inputId].value);
              setEditedSections(prev => ({ ...prev, [`section-${section.index}`]: false }));
            } else {
              onUpdatingPage(section.index, page.index, inputRef.current[inputId].value);
              setEditedPages(prev => ({ ...prev, [`page-${section.index}-${page.index}`]: false }));
            }
            setRenderedOn(Date.now());
          }}>
          {t("Save.label")}
        </button>
        <button className='btn-secondary me-2'
          onClick={() => {
            if (forSection) {
              setEditedSections(prev => ({ ...prev, [`section-${section.index}`]: false }));
            } else {
              setEditedPages(prev => ({ ...prev, [`page-${section.index}-${page.index}`]: false }));
            }
            setRenderedOn(Date.now());
            onContentEdited(false);
          }}>
          {t("Cancel.label")}
        </button>
      </div>
    </div>);
  };

  const getSectionMenuPermissions = (section, page, forSection) => {
    const isContentsSection = section.type === ReportSection.CONTENTS;
    const isTocPage = page?.type === ReportPageType.CONTENTS;
    return {
      canDelete: forSection ? !isContentsSection : !isTocPage,
      canEdit: forSection ? !isContentsSection : !isTocPage,
    };
  };

  const getMoreOptions = ({ forSection, section, page }) => {
    let dropId;
    if (forSection) {
      dropId = `moreDropdown-${section.index}`;
    } else {
      dropId = `moreDropdown-${section.index}-${page.index}`;
    }
    const { canDelete, canEdit } = getSectionMenuPermissions(section, page, forSection);
    return (
      <Dropdown>
        <Dropdown.Toggle
          variant="blank_outline"
          id={dropId}>
          <BiDotsHorizontalRounded />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {
            canEdit &&
            <Dropdown.Item onClick={() => {
              if (forSection) {
                setEditedSections(prev => ({ ...prev, [`section-${section.index}`]: true }));
              } else {
                setEditedPages(prev => ({ ...prev, [`page-${section.index}-${page.index}`]: true }));
              }
              setRenderedOn(Date.now());
              onContentEdited(true);
            }}>
              {t("Edit.label")}
            </Dropdown.Item>
          }
          {
            forSection &&
            <Dropdown.Item onClick={() => {
              onAddingNewPage(section.index);
            }}>
              {t("NewPage.label")}
            </Dropdown.Item>
          }
          {
            canDelete &&
            <Dropdown.Item onClick={() => {
              if (forSection) {
                setItemToDelete({ forSection: true, section, page: null });
              } else {
                setItemToDelete({ forSection: false, section, page });
              }
              setRenderedOn(Date.now());
            }}>
              {t("Delete.label")}
            </Dropdown.Item>
          }

        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const renderRootPages = (section, sIndex) => {
    return (
      <>
        {
          section.pages?.map((page, pIndex) => {
            return renderPageLink({
              sIndex: sIndex,
              pIndex: pIndex,
              section: section,
              page: page
            });
          })
        }
      </>
    );
  };
  // const LinktodatasourceHelpText = (
  //   <Tooltip id="Risk_help_test">
  //     {page.name}
  //   </Tooltip>
  // );

  const renderPageLink = ({ sIndex, pIndex, section, page }) => {
    const { canEdit, canDelete } = getSectionMenuPermissions(section, page, false);
    return (
      <li key={`sectionPageItem-${sIndex}-${pIndex}`}>
        {
          draggedOver.pageId === page.index && draggedOver.sectionId === section.index && <PageDropSpacer />
        }
        {
          !editedPages[`page-${section.index}-${page.index}`]
            ?
            <div className='' onDragOver={(e) => onDragOver(e, page, section)}>
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="button-tooltip-2"> {page.name}</Tooltip>}
              >
                <span>
                  <a
                    data-tooltip-id="my-tooltip" data-tooltip-content="Hello world!"
                    className={activeSectionIndex === section.index && activePageIndex === page.index ? 'cursor active' : 'cursor'}
                    draggable={true}
                    onDragStart={(e) => onPageDragStart(e, page, section)}
                    onDragEnd={(e) => onPageDragEnd(e, page)}
                    onClick={() => onPageChange(section.index, page.index)}>
                    {page.name}
                  </a>
                  <span className='text-right'>
                    {(canEdit || canDelete) && getMoreOptions({ forSection: false, section: section, page: page })}
                  </span>
                </span>
              </OverlayTrigger>
            </div>
            : <>{getEditTextField({ forSection: false, section: section, page: page, value: page.name })}</>
        }
      </li>
    );
  };

  const canRenderSection = (section) => {
    return section.type === ReportSection.CONTENTS
      || section.type === ReportSection.OTHERS
      || section.type === ReportSection.OVERVIEW
      || section.type === ReportSection.REPORTING
      || section.type === ReportSection.LEADERSHIP
      || section.type === ReportSection.ABOUT_REPORT
      || section.type === ReportSection.ABOUT_COMPANY
      || section.type === ReportSection.ESG_APPROACH
      || section.type === ReportSection.ENVIRONMENT
      || section.type === ReportSection.SOCIAL
      || section.type === ReportSection.GOVERNANCE
      || section.type === ReportSection.ESG_INDEX
      || section.type === ReportSection.ROOT;
  };

  const renderExpandOrCollapseIcon = (s) => {
    return (
      <span className='cursor action-icon' onClick={() => {
        const d = JSON.parse(JSON.stringify(hiddenSection));
        d[s.index] = d[s.index] ? !d[s.index] : true;
        setHiddenSection(d);
      }}>
        {hiddenSection[s.index] === true ? <FaChevronRight /> : <FaChevronDown />}
      </span>
    );
  };

  const renderSuggestedSections = () => {
    const suggestions = [
      { pageType: ReportPageType.MSG_FROM_CSO, sectionType: ReportSection.LEADERSHIP, name: 'Message from the Chief Sustainability Officer' },
      { pageType: ReportPageType.CONTRIB_TO_UN_SDGS, sectionType: ReportSection.ESG_APPROACH, name: 'Contribution to UN SDGs' },
      { pageType: ReportPageType.BIODIVERSITY, sectionType: ReportSection.ENVIRONMENT, name: 'Biodiversity' },
      { pageType: ReportPageType.SUPPLIERS, sectionType: ReportSection.SOCIAL, name: 'Suppliers' },
      // { pageType: ReportPageType.HUMAN_RIGHTS, sectionType: ReportSection.GOVERNANCE, name: 'Human Rights'},
      // { pageType: ReportPageType.ETHICS_COMP, sectionType: ReportSection.GOVERNANCE, name: 'Ethics & Compliance'},
      // { pageType: ReportPageType.TAX_POLICY, sectionType: ReportSection.GOVERNANCE, name: 'Tax Policy'},
      // { pageType: ReportPageType.BC_DIS_RECOVERY, sectionType: ReportSection.GOVERNANCE, name: 'Business Continuity/Disaster Recovery'},
      // { pageType: ReportPageType.EXT_ASSURANCE, sectionType: ReportSection.ROOT, name: 'External Assurance '}
    ];
    return (
      <ul>
        <li>
          <span>
            <a className='cursor'><b>{t('SuggestedSections.label')}</b></a>
          </span>
          <ul>
            {
              suggestions?.map((suggestion, index) => {
                return (
                  <li id={`suggestion-${index}`} key={`suggestion-${index}`}>
                    <div className="">
                      <span>
                        <a data-tooltip-id={`suggestionTooltip-${index}`}
                          data-tooltip-content={suggestion.name}
                          className="cursor"
                          draggable="true">{suggestion.name}</a>
                        <span className="text-right">
                          <div className="dropdown">
                            <button type="button"
                              id={`suggestionIcon-${index}`}
                              aria-expanded="false"
                              className="dropdown-toggle btn btn-blank_outline">
                              <BsPlus onClick={() => addPageFromSuggestion(suggestion)} />
                            </button>
                          </div>
                        </span>
                      </span>
                    </div>
                  </li>
                );
              })
            }
          </ul>
        </li>
      </ul >
    );
  };

  const addPageFromSuggestion = (suggestion) => {
    let p;
    switch (suggestion.pageType) {
      case ReportPageType.MSG_FROM_CSO:
        p = ReportingUtils.getMSGFromCSOPage();
        break;
      case ReportPageType.SUPPLIERS:
        p = ReportingUtils.getSuppliersPage();
        break;
      case ReportPageType.HUMAN_RIGHTS:
        p = ReportingUtils.getHumanRightsPage();
        break;
      case ReportPageType.ETHICS_COMP:
        p = ReportingUtils.getEthicsPage();
        break;
      case ReportPageType.TAX_POLICY:
        p = ReportingUtils.getTaxPolicyPage();
        break;
      case ReportPageType.BC_DIS_RECOVERY:
        p = ReportingUtils.getBCDiscoveryPage();
        break;
      case ReportPageType.CONTRIB_TO_UN_SDGS:
        p = ReportingUtils.getContribToUNSDGsPage();
        break;
      case ReportPageType.BIODIVERSITY:
        p = ReportingUtils.getBiodiversityPage();
        break;
      default:
        break;
    }
    if (!p) return;

    onAddingNewPageFromSuggestion(p);
  }

  const getSectionDisplayName = (section) => {
    if (section.type === ReportSection.CONTENTS) {
      return t('Contents.label');
    }
    return section.name;
  };

  // Rest of your component 

  return (
    <div className={`Reporting_SiderBar ${sidebarDisplay ? '' : 'left-44'}`}>
      <ul className='Reporting_siderBar_ul'>
        <li className='Reporting_SiderBar_title'>
          <a
            className={activeSectionIndex === 0 ? 'cursor active' : 'cursor'}
            onClick={() => onPageChange(0, 0)}><strong>Title</strong></a>
        </li>
        {
          sections?.filter(section => canRenderSection(section))
            ?.map((section, sIndex) => {
              if (section.type === ReportSection.ROOT) {
                return renderRootPages(section, sIndex);
              } else {
                return (
                  <li key={`otherSectionItem-${sIndex}`}>
                    {
                      !editedSections[`section-${section.index}`]
                        ?
                        <span>
                          {renderExpandOrCollapseIcon(section)}
                          <a className='cursor'><b>{getSectionDisplayName(section)}</b></a>
                          <span className='text-right'>
                            {getMoreOptions({ forSection: true, section: section })}
                          </span>
                        </span>

                        : <>{getEditTextField({ forSection: true, section: section, value: section.name })}</>
                    }
                    {
                      hiddenSection[section.index] !== true &&
                      <ul>
                        {
                          section.pages?.map((page, pIndex) => {
                            return renderPageLink({
                              sIndex: sIndex,
                              pIndex: pIndex,
                              section: section,
                              page: page
                            });
                          })
                        }
                      </ul>
                    }
                  </li>
                );
              }
            })
        }

      </ul>
      {renderSuggestedSections()}
      <div className='Reporting_siderBar_btnBox'>
        {
          !showNewSectionEditor &&
          <div className='Reporting_siderBar_NewSectionBox'>
            <button className="btn btn-primary"
              onClick={() => {
                setShowNewSectionEditor(true);
                onContentEdited(true);
              }}><FaPlus /> {t("NewSection.label")} </button>
          </div>
        }
        {
          showNewSectionEditor &&
          <div>
            <div>
              <input type="text"
                id="newSectionInput"
                className="form-control"
                maxLength={100}
                ref={ref => inputRef.current['newSectionInput'] = ref} />
            </div>
            <div className='mt-2'>
              <button className='btn btn-primary me-2 px-3'
                onClick={() => {
                  onAddingNewSection(inputRef.current['newSectionInput'].value);
                  setShowNewSectionEditor(false);
                }}>
                {t("Save.label")}
              </button>
              <button className='btn btn-secondary me-2'
                onClick={() => {
                  setShowNewSectionEditor(false);
                  onContentEdited(false);
                }}>
                {t("Cancel.label")}
              </button>
            </div>
          </div>
        }
        {
        (itemToDelete?.section?.id > 0 || itemToDelete?.page?.id > 0 )&&(
          <ConfirmationModal
          title={t("confirmation.label")}
          modalShow={ itemToDelete?.section?.id > 0 || itemToDelete?.page?.id > 0}
          messageText={t(itemToDelete.forSection ? "DeleteSection.label" : "DeletePage.label")}
          callbackModal={saveChangesConfirmationCallBack}>
          <div className='text-center'> {t(itemToDelete.forSection ? "DeleteSection.label" : "DeletePage.label")}</div>
        </ConfirmationModal>
        )

        }
      </div>
    </div >);
}

export default withTranslation()(ReportingSidebar);


const PageDropSpacer = () => {
  return (
    <div className="pt-3 pb-3"
      style={{ backgroundColor: 'lightcyan' }}>
    </div>
  );
};
